import React from "react";
import { FaPiggyBank, FaHandHoldingDollar } from "react-icons/fa6";
import { useAppSelector } from "@hypexone/uicore";
import Button from "../shared/Button/Button";

interface WithdrawAndDepositBarProps {
  onDepositClick: () => void;
  onWithdrawClick: () => void;
}

const BarActionButton: React.FC<{
  text: string;
  bgFrom: string;
  bgTo: string;
  onClick: () => void;
  icon: React.ReactNode;
}> = ({ text, bgFrom, bgTo, onClick, icon }) => (
  <Button
    onClick={onClick}
    className="relative flex h-[30px] flex-1 items-center justify-center gap-1 overflow-hidden rounded-md border-0 py-0 text-[12px] font-extrabold uppercase leading-none tracking-[0.02em] text-white shadow-[0_1px_3px_rgba(0,0,0,0.2)] active:translate-y-px"
    style={{
      background: `linear-gradient(180deg, ${bgFrom} 0%, ${bgTo} 100%)`,
    }}
  >
    <span
      aria-hidden
      className="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/20 to-transparent"
    />
    <span className="relative flex shrink-0 items-center justify-center text-[15px] leading-none">
      {icon}
    </span>
    <span className="relative">{text}</span>
  </Button>
);

/** Mobile-only Deposit / Withdraw strip under news — compact like main reference. */
const WithdrawAndDepositBar: React.FC<WithdrawAndDepositBarProps> = ({
  onDepositClick,
  onWithdrawClick,
}) => {
  const { langData } = useAppSelector((state) => state.cms);

  return (
    <div className="flex w-full gap-1 bg-[#ececec] px-1 py-0.5 md:hidden">
      <BarActionButton
        onClick={onDepositClick}
        text={langData?.["deposit"] || "Deposit"}
        bgFrom="#43A047"
        bgTo="#2E7D32"
        icon={<FaPiggyBank aria-hidden />}
      />
      <BarActionButton
        onClick={onWithdrawClick}
        text={langData?.["withdraw"] || "Withdraw"}
        bgFrom="#E53935"
        bgTo="#C62828"
        icon={<FaHandHoldingDollar aria-hidden />}
      />
    </div>
  );
};

export default WithdrawAndDepositBar;
